import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const DAP_DDP_CHECKOUT = 'DAP-Checkout-Treatment-Test-Q3-2023';

export const isDapDdpCheckoutVariant = getAbTestV2(DAP_DDP_CHECKOUT)?.variant === 'variant';

export const trackDapDdpCheckoutABTest = (): void => trackAbTestV2Variant(DAP_DDP_CHECKOUT);
